import flags from '../feature_flags.json';

// on = feature is available
// off = feature is hidden

const isFeatureOn = (feature) => {
  return flags[feature] === 'on';
};

export {
  isFeatureOn
};
